import type {
	PurchaseReason,
	PurchaseSatisfaction,
	RepurchaseIntent,
} from "@sobidogam/domain";

export const SATISFACTION_LABELS: Record<PurchaseSatisfaction, string> = {
	better_than_expected: "기대보다 좋았어요",
	as_expected: "기대한 만큼이었어요",
	mixed: "좋고 아쉬운 점이 섞였어요",
	not_for_me: "나와는 잘 맞지 않았어요",
};

export const REPURCHASE_LABELS: Record<RepurchaseIntent, string> = {
	yes: "다시 살래요",
	maybe: "조금 더 써볼래요",
	no: "다음엔 다른 걸 고를래요",
};

export const PURCHASE_REASON_LABELS: Record<PurchaseReason, string> = {
	needed_now: "지금 필요해서",
	planned: "계획해 둬서",
	curious: "궁금해서",
	treat: "나를 위한 작은 보상",
	together: "함께 쓰려고",
	gift: "선물하려고",
};
